import React from 'react';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import * as appActions from '../App/store/actions';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getUser } from '../App/store/reducers';
import Utils from 'utils/utils';
import WEAppBar from 'components/UI/WEAppBar/WEAppBar';
import WETopBar from 'components/UI/WETopBar/WETopBar';
import { Text } from 'bohr-web';

const AppHeader = (props) => {
  const pageNameMapping = {
    '/portal/consigner': 'Consigner',
    '/portal/operator': 'Operator',
    '/portal/third-party': 'Third Party',

    '/portal/ticketing': 'Ticketing',
    '/portal/ptl-ticketing': 'PTL Ticketing',

    '/portal/placement': 'Placement',
    '/portal/operations': 'Operations',
    '/portal/pod': 'POD',
    // '/portal/invoice': 'Invoice',
    '/portal/create-demand': 'Create Demand',
    '/portal/create-demand-ptl': 'Create Demand PTL(BULK)',
    '/portal/ptl-bulk-mis': 'PTL MIS(BULK)',
    '/portal/ptl-freight-upload': 'PTL Freight/Invoice Upload',
    '/portal/ptl-tasks': 'PTL Tasks',
    '/portal/update-vehicle': 'Update Vehicle',
    '/portal/lms': 'Lead Management System',
    '/portal/transactions': 'Transaction',
    '/portal/cms': 'SEO CMS',
    '/portal/issue-creation': 'Issue Creation',
    '/portal/permissions': 'Permissions',
    '/portal/lane-rate-dashboard': 'Lane Rate Dashboard',
    '/portal/operator-rate-info': 'Operator Rate Info',
    '/portal/manual-placement': 'Manual Placement',
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    props.logoutForUser();
    Utils.reAuthenticate();
  };

  return (
    <WEAppBar>
      <WETopBar>
        <Text text={pageNameMapping[props.location.pathname]} color="rgba(58, 58, 58, 1)" size="20px" weight={700} />
        <div>
          <IconButton
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={open}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose}>{'Hello User'}</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </div>
      </WETopBar>
    </WEAppBar>
  );
};

function mapDispatchToProps(dispatch) {
  const logoutForUser = appActions.forUser.signOut;
  return bindActionCreators({ logoutForUser }, dispatch);
}

function mapStateToProps(state, props) {
  return {
    userInfo: getUser(state),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppHeader));
